var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"prefix w-2 h-2 rounded-full border border-gray-200",style:(("background-color: " + _vm.prefixGenerate))})}
var staticRenderFns = []

export { render, staticRenderFns }